import { render } from "./mobile-money-franco.vue?vue&type=template&id=55b4a848&scoped=true"
import script from "./mobile-money-franco.vue?vue&type=script&lang=js"
export * from "./mobile-money-franco.vue?vue&type=script&lang=js"

import "./mobile-money-franco.vue?vue&type=style&index=0&id=55b4a848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b4a848"]])

export default __exports__